/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { TextPattern } from '../model/text-pattern.model';

export class TextProvider {
  private static patternMap = new Map<string, { [key: string]: TextPattern }>();

  static registerTextPatterns(key: string, patterns: { [key: string]: TextPattern }) {
    TextProvider.patternMap.set(key, patterns);
  }

  static resolveTextPatterns(key: string): { [key: string]: TextPattern } {
    return TextProvider.patternMap.get(key);
  }

  static getTextPatters(): Map<string, { [key: string]: TextPattern }> {
    return TextProvider.patternMap;
  }

}
